import React, { useEffect, useState } from "react";

export default (props) => {

  const [fieldValue, setFieldValue] = useState()

  useEffect(() => {
    setFieldValue(props.value)
  }, [props.value])


  return (
    <div className="flex flex-col space-y-3 w-full text-right">
      <label className=" text-gray-500">{props.label} {props.required ? <i className="text star ">*</i> : ''}</label>
      <input
        readOnly={props.readOnly}
        className="w-full border border-neutral-300 p-3 rounded-md text-right"
        onChange={(e) => setFieldValue(e.target.value)}
        defaultValue={fieldValue}
        maxLength={props.maxLength ?? ""}
        autoComplete="off"
        pattern={props.pattern}
        style={props.style}
        name={props.name}
        id={props.name}
        type={props.type}
      />
    </div>
  );
};
